// #region imports

// --- HS Code
import { Constants } from "../shared/constants";
import { InvitationTypes } from "../shared/invitation-types";
import { RespondentModel } from "./respondent-model";

// #endregion

export class Respondent implements RespondentModel {
  static CreateEmpty(groupId: string, groupIndex: number, participantId: string) {
    return new Respondent(groupId, groupIndex, participantId)
  }

  constructor(
    public groupId: string,
    public groupIndex: number,
    public participantId: string
  ) {
    this.firstName = '';
    this.lastName = '';
    this.emailAddress = '';
  }

  public id: string | null = null;
  public firstName: string;
  public lastName: string;
  public emailAddress: string;
  public avatar: string = '';
  public percentageComplete: number = 0;
  public status: number = 0;
  public locale: string = Constants.DEFAULT_LOCALE;
  public languageId: number = Constants.DEFAULT_LANGUAGE.id;
  public isValid: boolean = false;
  public isSet: boolean = false;
  public errorMessage: string = '';
  public personalMessage: string = '';
  public isValidatingEmailAddress: boolean = false;
  public isSaving: boolean = false;
  public isSendingReminder: boolean = false;
  public isExpanded: boolean = false;
  public lastEmailSentDate: string | null = null;
  public invitationType: InvitationTypes = InvitationTypes.unknown;
  public canResendEmail: boolean = false;
}
